module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_10.2f1aea99.pdf";